import { render, staticRenderFns } from "./TransferTestators.vue?vue&type=template&id=b1f864c2&scoped=true"
import script from "./TransferTestators.vue?vue&type=script&lang=js"
export * from "./TransferTestators.vue?vue&type=script&lang=js"
import style0 from "./TransferTestators.vue?vue&type=style&index=0&id=b1f864c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f864c2",
  null
  
)

export default component.exports